import { useContext, useEffect, useState } from "react";
import { AppDB } from "../../../App";
import { votersService } from "../../../services/VotersService";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import MultiFilterSearch from "../../../componets/MultiFilterSearch";



export default function AddCandidateComponet({ required = false, info, ignoreEligibity = false, delimitationID = null, isCandidate = false, name = "", isNational = false, error = "", show = false, label = "Search Elector", onUpdate = () => { } }) {


    var { toast } = useContext(AppDB)
    var [loading, setLoading] = useState(false);
    var [form, setForm] = useState({
        idNumber: "",
        voterRecord: null
    })
    function searchVoterByIDNumber() {
        setLoading(true);
        votersService.getByIDNumber(form.idNumber).then((res) => {
            setLoading(false);;
            var status = `${res}`
            if (status.trim().length === 0) {

                toast.show({
                    severity: "error",
                    detail: name + " not found",
                    life: 2500
                });
                onUpdate(null, null, null, form.idNumber)
                setForm({
                    ...form,
                    village: null,
                    voterRecord: null
                });
                return true
            } else {

                if (ignoreEligibity === true) {
                    if (res.eligibleStatus === "N") {
                        toast.show({
                            severity: "error",
                            detail: name + " not eligible",
                            life: 2500
                        });
                        onUpdate(null, null, null, form.idNumber)
                        setForm({
                            ...form,
                            village: null,
                            voterRecord: null
                        });
                        return
                    }
                }


                {/* // councilID constituencyId
                            if(selectedCanditate?.event?.isNationalDelimitation){
                                // if(selectedCanditate?.delimitationID===refresh.village.console)
                            } */}


                if (isCandidate) {


                    if (isNational) {
                        if (delimitationID !== res.village.constituencyID) {
                            toast.show({
                                severity: "error",
                                detail: `${name} must be in the same demarcation '${info.constituency_name}' where the event is taking place`,
                                life: 5000
                            });
                            onUpdate(null, null, null, form.idNumber)
                            setForm({
                                ...form,
                                village: null,
                                voterRecord: null
                            });
                            return
                        }
                    } else {
                        if (delimitationID !== res.village.electorDivisionID) {
                            toast.show({
                                severity: "error",
                                detail: name + " must be in the same demarcation where the event is taking place",
                                life: 5000
                            });
                            onUpdate(null, null, null, form.idNumber)
                            setForm({
                                ...form,
                                village: null,
                                voterRecord: null
                            });
                            return
                        }
                    }
                }

                setForm({
                    ...form,
                    village: res?.village,
                    voterRecord: {
                        firstname: res.firstname,
                        surname: res.surname,
                        dateOfBirth: res.dateOfBirth,
                        gender: res.gender,
                        voterID: res.voterID,
                        registrationNumber: res.registrationNumber
                    }
                });
                onUpdate(res.voterID, `${res.firstname} ${res.surname}`, res.village, form.idNumber)
            }
        });
    }

    return (<>
        <div style={{ display: show ? "block" : "none" }}>
            <div className="grid my-2" >

                <div className="col-12 card">
                    <b>{label} {required ? <span style={{ color: "red" }}>*</span> : ""}</b>

                    <MultiFilterSearch
                        label=""
                        onClear={() => {
                            onUpdate(null, null, null, form.idNumber)
                            setForm({
                                ...form,
                                village: null,
                                voterRecord: null
                            });
                        }}
                        onChange={res => {

                            if (isCandidate) {

                                if (isNational) {
                                    if (delimitationID !== res.village.constituencyID) {
                                        toast.show({
                                            severity: "error",
                                            detail: `${name} must be in the same demarcation '${info.constituency_name}' where the event is taking place`,
                                            life: 5000
                                        });
                                        onUpdate(null, null, null, form.idNumber)
                                        setForm({
                                            ...form,
                                            village: null,
                                            voterRecord: null
                                        });
                                        return
                                    }
                                } else {
                                    if (delimitationID !== res.village.electorDivisionID) {
                                        toast.show({
                                            severity: "error",
                                            detail: name + " must be in the same demarcation where the event is taking place",
                                            life: 5000
                                        });
                                        onUpdate(null, null, null, form.idNumber)
                                        setForm({
                                            ...form,
                                            village: null,
                                            voterRecord: null
                                        });
                                        return
                                    }
                                }
                            }

                            setForm({
                                ...form,
                                village: res?.village,
                                voterRecord: {
                                    firstname: res.firstname,
                                    surname: res.surname,
                                    dateOfBirth: res.dateOfBirth,
                                    gender: res.gender,
                                    voterID: res.voterID,
                                    registrationNumber: res.registrationNumber
                                }
                            });

                            onUpdate(res.voterID, `${res.firstname} ${res.surname}`, res.village, form.idNumber,res.firstname,res.surname)

                        }} />

                    {/* <div className=" flex my-2">
                        <InputText
                            maxLength={12}
                            style={{ width: "100%" }}
                            placeholder="National ID"
                            value={form.idNumber}
                            onChange={(e) => {
                                setForm({ ...form, idNumber: e.target.value.trim().toLowerCase() });
                            }}
                        />
                        <div></div>
                        <Button
                            className="ml-2"
                            loading={loading}
                            disabled={form.idNumber.length !== 12}
                            label="Search"
                            onClick={() => {
                                searchVoterByIDNumber();
                            }}
                        />
                    </div> */}

                    {form.voterRecord !== null && (<div className="grid">
                        <div className="col-12  md:col-4">
                            <div>First Name</div>
                            <div className=" p-inputtext p-component p-filled">{form.voterRecord?.firstname}</div>
                        </div>
                        <div className="col-12  md:col-4 ">
                            <div>Surname</div>
                            <div className=" p-inputtext p-component p-filled">{form.voterRecord?.surname}</div>
                        </div>
                        <div className="col-12  md:col-4 ">
                            <div>Registration No.</div>
                            <div className=" p-inputtext p-component p-filled">{form.voterRecord?.registrationNumber}</div>
                        </div>
                        <div className="col-12">
                            <hr />
                        </div>
                    </div>)}
                    {!["", null, undefined].includes(error) && <span style={{ color: "red" }}>{error}</span>}
                </div>


            </div>

        </div>

    </>)
}